/**
 * filesize
 *
 * @method filesize
 * @param  {Mixed}   arg        String, Int or Float to transform
 * @param  {Object}  descriptor [Optional] Flags
 * @return {String}             Readable file size String
 *
 filesize(500);                        // "500 B"
 filesize(500, {bits: true});          // "4 kbit"
 filesize(265318, {base: 2});          // "259.1 KiB"
 filesize(265318);                     // "265.32 kB"
 filesize(265318, {round: 0});         // "265 kB"
 filesize(265318, {output: "array"});  // [265.32, "kB"]
 filesize(265318, {output: "object"}); // {value: 265.32, symbol: "kB", exponent: 1, unit: "kB"}
 filesize(1, {symbols: {B: "Б"}});     // "1 Б"
 filesize(1024);                       // "1.02 kB"
 filesize(1024, {exponent: 0});        // "1024 B"
 filesize(1024, {output: "exponent"}); // 1
 filesize(265318, {standard: "jedec"});  // "259.1 KB"
 filesize(265318, {base: 2, fullform: true}); // "259.1 kibibytes"
 filesize(12, {fullform: true, fullforms: ["байтов"]});  // "12 байтов"
 filesize(265318, {separator: ","});   // "265,32 kB"
 filesize(265318, {locale: "de"});   // "265,32 kB"
 */

import bytes from "bytes";
import { isUndefined } from "lodash";
import { round } from "lodash-es";

export function filesize(
  arg: number,
  options?: { output?: "exponent"; round?: number; base?: 2 | 10 }
): string {
  if (isNaN(arg)) {
    throw new TypeError("Invalid number");
  }

  if (!isUndefined(options?.round)) {
    arg = round(arg, options.round);
  }

  // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
  return bytes(arg, {
    decimalPlaces: 1,
    fixedDecimals: true
  });
}
